import { render, staticRenderFns } from "./PurchaseProtocol.vue?vue&type=template&id=c36652d8&scoped=true&"
import script from "./PurchaseProtocol.vue?vue&type=script&lang=js&"
export * from "./PurchaseProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProtocol.vue?vue&type=style&index=0&id=c36652d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36652d8",
  null
  
)

export default component.exports